import React from "react";
import CustomizeOption from "./customizeOption";
import { useDispatch, useSelector } from "react-redux";
import { handleStructure } from "../DSFunction";
import CapacityOption from "./capacityOption";
import PVModuleOption from "./pvModuleOption";

export default function CustomizeStructure({emptyValues}) {
  const dispatch = useDispatch();
  const roofInfo = useSelector((state) => state.roof);
  const gridInfo = useSelector((state) => state.grid);
  const quantityInfo = useSelector((state) => state.quantity);
  const designParameter = useSelector((state) => state.designParameter);

  const roofData = quantityInfo.roofData;
  const roofIndex = quantityInfo.roofNo;
  const roofDetail = roofData.length > 0 ? roofData[roofIndex] : [];

  const handleKeyPress = (e) => {
    if (e.which < 48 || e.which > 57) {
      e.preventDefault();
    }
    if (e.key === "Enter") {
      handleStructure({
        dispatch,
        roofInfo,
        gridInfo,
        quantityInfo,
        roofDetail,
        designParameter,
      });
    }
  };

  return (
    <React.Fragment>
      <PVModuleOption
        emptyValues={emptyValues}
        handleKeyPress={handleKeyPress}
      ></PVModuleOption>
      <CustomizeOption handleKeyPress={handleKeyPress}></CustomizeOption>
      <CapacityOption handleKeyPress={handleKeyPress}></CapacityOption>
    </React.Fragment>
  );
}
